import { ExpandedTooltip, Icon } from '@livable/saas-react-components';
import {
// NOTE: disabled check payout LB-1758
// Button,
// Chip,
Grid, IconButton, InputAdornment, TextField, Typography } from '@mui/material';
import { observer } from 'mobx-react-lite';
import React from 'react';
import { useTranslation } from 'react-i18next';
// NOTE: disabled check payout LB-1758
// import { PAYMENT_METHODS } from 'src/constants/payments';
import { translate } from 'src/utils/translator';
import useStyles from './styles';
export const ACHPaymentOptionForm = observer(
// eslint-disable-next-line @typescript-eslint/no-unused-vars
_ref => {
  let formik = _ref.formik,
    handlePrimaryPaymentMethodChange = _ref.handlePrimaryPaymentMethodChange,
    isDisabled = _ref.isDisabled;
  const classes = useStyles();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement("div", {
    className: classes.wrapper
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.header
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.headerText
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h4"
  }, t('add_new_property_flow.ach_direct_deposit')), /*#__PURE__*/React.createElement("div", {
    className: classes.xsSection
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body1"
  }, t('add_new_property_flow.ach_form_hint')), /*#__PURE__*/React.createElement(Typography, {
    variant: "body1"
  }, t('add_new_property_flow.hereby_authorize'))))), /*#__PURE__*/React.createElement("div", {
    className: classes.form
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    rowSpacing: 24,
    columnSpacing: 10
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(TextField, {
    id: "nameOnAccount",
    name: "nameOnAccount",
    label: t('add_new_property_flow.name_on_the_account'),
    variant: "outlined",
    value: formik.values.nameOnAccount,
    onChange: formik.handleChange,
    onBlur: formik.handleBlur,
    InputProps: {
      endAdornment: /*#__PURE__*/React.createElement(InputAdornment, {
        position: "end",
        type: "infoTooltip"
      }, /*#__PURE__*/React.createElement(ExpandedTooltip, {
        type: "grey",
        title: t('add_new_property_flow.name_on_account_tooltip'),
        placement: "top"
      }, /*#__PURE__*/React.createElement(IconButton, null, /*#__PURE__*/React.createElement(Icon, {
        type: "question"
      }))))
    },
    error: formik.touched.nameOnAccount && Boolean(formik.errors.nameOnAccount),
    helperText: formik.touched.nameOnAccount && translate(t(formik.errors.nameOnAccount, {
      field: t('general.email_address')
    }), t),
    fullWidth: true,
    disabled: isDisabled
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(TextField, {
    id: "depositoryName",
    name: "depositoryName",
    label: t('add_new_property_flow.depository_name'),
    variant: "outlined",
    value: formik.values.depositoryName,
    onChange: formik.handleChange,
    onBlur: formik.handleBlur,
    InputProps: {
      endAdornment: /*#__PURE__*/React.createElement(InputAdornment, {
        position: "end",
        type: "infoTooltip"
      }, /*#__PURE__*/React.createElement(ExpandedTooltip, {
        type: "grey",
        title: t('add_new_property_flow.depository_name_tooltip'),
        placement: "top"
      }, /*#__PURE__*/React.createElement(IconButton, null, /*#__PURE__*/React.createElement(Icon, {
        type: "question"
      }))))
    },
    error: formik.touched.depositoryName && Boolean(formik.errors.depositoryName),
    helperText: formik.touched.depositoryName && translate(t(formik.errors.depositoryName, {
      field: t('general.email_address')
    }), t),
    fullWidth: true,
    disabled: isDisabled
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React.createElement(TextField, {
    id: "routingNumber",
    name: "routingNumber",
    label: t('add_new_property_flow.routing_number'),
    variant: "outlined",
    value: formik.values.routingNumber,
    onBlur: formik.handleBlur,
    InputProps: {
      endAdornment: /*#__PURE__*/React.createElement(InputAdornment, {
        position: "end",
        type: "infoTooltip"
      }, /*#__PURE__*/React.createElement(ExpandedTooltip, {
        type: "grey",
        title: t('add_new_property_flow.routing_number_tooltip'),
        placement: "top"
      }, /*#__PURE__*/React.createElement(IconButton, null, /*#__PURE__*/React.createElement(Icon, {
        type: "question"
      }))))
    },
    onKeyPress: event => {
      if (!/[0-9]/.test(event.key)) {
        event.preventDefault();
      }
    },
    onChange: e => {
      if (!/^[0-9][0-9]*$|^$/.test(e.target.value)) return;
      formik.handleChange(e);
    },
    error: formik.touched.routingNumber && Boolean(formik.errors.routingNumber),
    helperText: formik.touched.routingNumber && translate(t(formik.errors.routingNumber, {
      field: t('general.email_address')
    }), t),
    fullWidth: true,
    disabled: isDisabled
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React.createElement(TextField, {
    id: "accountNumber",
    name: "accountNumber",
    label: t('add_new_property_flow.account_number'),
    variant: "outlined",
    value: formik.values.accountNumber,
    onBlur: formik.handleBlur,
    onKeyPress: event => {
      if (!/[0-9]/.test(event.key)) {
        event.preventDefault();
      }
    },
    onChange: e => {
      if (!/^[0-9][0-9]*$|^$/.test(e.target.value)) return;
      formik.handleChange(e);
    },
    InputProps: {
      endAdornment: /*#__PURE__*/React.createElement(InputAdornment, {
        position: "end",
        type: "infoTooltip"
      }, /*#__PURE__*/React.createElement(ExpandedTooltip, {
        type: "grey",
        title: t('add_new_property_flow.account_number_tooltip'),
        placement: "top"
      }, /*#__PURE__*/React.createElement(IconButton, null, /*#__PURE__*/React.createElement(Icon, {
        type: "question"
      }))))
    },
    error: formik.touched.accountNumber && Boolean(formik.errors.accountNumber),
    helperText: formik.touched.accountNumber && translate(t(formik.errors.accountNumber, {
      field: t('general.email_address')
    }), t),
    fullWidth: true,
    disabled: isDisabled
  })))));
});